import { render, staticRenderFns } from "./PlatformAdminLogin.vue?vue&type=template&id=4eb3076a&scoped=true&"
import script from "./PlatformAdminLogin.vue?vue&type=script&lang=js&"
export * from "./PlatformAdminLogin.vue?vue&type=script&lang=js&"
import style0 from "./PlatformAdminLogin.vue?vue&type=style&index=0&id=4eb3076a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb3076a",
  null
  
)

export default component.exports